import React from 'react';

// Styles
import './SidePanel.scss';

const SidePanel = () => {
  const baseClassName = 'SidePanel';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__hero`}>
        <div className={`${baseClassName}__hero__content`}>
          <h5 className={`${baseClassName}__hero__content__quote`}>
            “PI Perform has revolutionized the way we manage our team, making it easy to manage and have effective
            meetings, as well as helping us foster a positive and supportive work culture.”
          </h5>
          <div className={`${baseClassName}__hero__content__quote__meta`}>
            <div className={`${baseClassName}__hero__content__quote__meta__details`}>
              <h4 className={`${baseClassName}__hero__content__quote__meta__name`}>Amber Bryant</h4>
              <p className={`${baseClassName}__hero__content__quote__meta__position`}>HR Director, Keyrenter Denver</p>
            </div>
            <div className={`${baseClassName}__hero__content__quote__meta__img-wrapper`}>
              <img
                src="https://piprodperformassets.blob.core.windows.net/assets/key-renter-denver-logo.png"
                className={`${baseClassName}__hero__content__quote__meta__img-wrapper__img`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidePanel;
